<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Command</h4>
    <small class="text-muted">
      Use this page to send lock/unlock command for desired vehicle.
    </small>
    <hr >
    <b-row>
      <b-col md="4">
        <b-alert
          :show="notFound"
          variant="danger">{{ model.licensePlate }} cannot be found.</b-alert>
        <b-form-group label="Command to Send">
          <b-select
            v-model="model.command"
            :options="commands"/>
        </b-form-group>
        <b-form-group label="License Plate">
          <b-input v-model="model.licensePlate" />
        </b-form-group>
        <b-btn
          :disabled="isFetching"
          type="button"
          variant="primary"
          block
          @click="send">
          <i
            v-show="isFetching"
            class="fa fa-spin fa-spinner"/>
          Send Command
        </b-btn>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { server, toastr } from '@/services/'
import { sendEvent } from '@/services/socket'

export default {
  data() {
    return {
      notFound: false,
      isFetching: false,
      model: {
        command: 'unlock',
        licensePlate: ''
      },
      commands: [
        {value: 'unlock', text: 'Unlock vehicle'},
        {value: 'lock', text: 'Lock vehicle'}
      ]
    }
  },
  created() {
    sendEvent('CLEANER_EVENT', { page: '/command', eventName: 'PAGE_ACCESS'})
  },
  methods: {
    async send() {
      sendEvent('CLEANER_EVENT', {
        page: '/command',
        eventName: `SEND_COMMAND_${this.model.command.toUpperCase()}_${this.model.licensePlate.toUpperCase()}`,
        eventDetail: {
          licensePlate: this.model.licensePlate.toUpperCase(),
          command: this.model.command
        }
      })

      this.notFound = false
      this.isFetching = true
      let { data } = await server.post('/proxy/cocos/getCars', {ACTIVE: true})
      let car = data.msgContent.data.find(car => car.LICENSE_PLATE === this.model.licensePlate.toUpperCase())
      if (!car) {
        this.isFetching = false
        this.notFound = true
      } else {
        let payload = {
          carCode: car.CODE,
          carLockUnlock: this.model.command === 'lock' ? 0 : 1
        }
        this.$store.dispatch('cleaning/lockUnlockCar', payload).then(
          resp => {
            let { data } = resp
            this.isFetching = false
            let toastrText = `${this.commands.find(obj => obj.value === this.model.command).text}`
            if (!data.msgContent.errMsg && data.msgContent.status > 0) {
              this.model.licensePlate = ''
              toastr.info(`${toastrText} succeed.`)
            } else {
              toastr.error(`${toastrText} failed.`)
            }
          }
        ).catch(() => toastr.serverError())
      }
    }
  }
}
</script>
